import { Stack, styled, TextField } from '@mui/material'
import calendarImage from '../../../../assets/calendar.svg'

export const ContainerModalSetFilter = styled(Stack)({
  height: 'max-content',
  maxHeight: '150px',
  borderRadius: '8px',
  fontSize: '12px',
  fontFamily: 'Nunito',
  overflowY: 'auto',
  background: '#242428',
  boxShadow: '-2px 2px 4px 1px rgba(0, 0, 0, 0.50)',
  padding: '16px',
  gap: '16px',
  overflowX: 'hidden'
})

export const TextFieldStyle = styled(TextField)(({ theme, myerror, value }) => {
  let color = 'white'
  if (!value) {
    color = 'grey'
  }
  return {
    border: myerror === 'true' ? `1px solid ${theme.palette.button.delete.primary}` : 'none',
    borderRadius: '4px',
    width: '100%',
    fontSize: '14px',
    color: 'white',
    '-webkit-text-fill-color': 'white !important',
    margin: '3.5px',
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="date"]::-moz-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="datetime-local"]::-moz-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& .MuiInputBase-input': {
      color: color,
      '-webkit-text-fill-color': `${color} !important`,
      padding: '11px 8px',
      fontSize: '14px',
      textOverflow: 'ellipsis'
    }
  }
})
